<template>
  <div
    class="
      text-xs
      sm:text-sm
      font-normal font-josefin
      text-counterText-light
      dark:text-counterText-dark
      transition-all
      duration-300
    "
  >
    {{ uncompletedTasks.length }} items left
  </div>
</template>
<script>
export default {
  name: "Counter",
  props: {
    uncompletedTasks: Array,
  },
};
</script>